module.exports = __webpack_public_path__ + "img/reset.6e996191.svg";